<template>
  <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4">
    <div class="flex-1 px-4">Subject</div>
    <div class="w-48 px-4">Project</div>
    <div class="w-48 px-4">Assigned to</div>
    <div
      class="w-32 px-4 text-blue-600 hover:underline"
      @click="toggleActiveSortingOption('status').refreshRouteSorting()"
    >
      <FontAwesomeIcon
        v-if="isSortingOptionActive('status')"
        :icon="getSortingOptionValue('status') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'"
        class="mr-2"
      />

      Status
    </div>
    <div
      class="w-32 px-4 text-blue-600 hover:underline"
      @click="toggleActiveSortingOption('due_at').refreshRouteSorting()"
    >
      <FontAwesomeIcon
        v-if="isSortingOptionActive('due_at')"
        :icon="getSortingOptionValue('due_at') > 0 ? 'sort-alpha-down' : 'sort-alpha-down-alt'"
        class="mr-2"
      />

      Due at
    </div>
    <div class="w-12 mr-2" />
  </div>
</template>

<script>
import sortMixin from '@/mixins/sortMixin';

export default {
  mixins: [sortMixin],
  watch: {
    $route: 'setInitialSortingValuesFromRoute',
  },
  created() {
    this.setSortingOptions(['status', 'due_at', 'created_at']).setInitialSortingValuesFromRoute(
      this.$route
    );
  },
};
</script>
